export default __webpack_public_path__ + "static/media/paper.f8d8a6cc.png";